import type { TooltipCommonProps } from '@wix/design-system';
import { Box, InfoIcon, Text, ToggleSwitch } from '@wix/design-system';
import React, { useContext } from 'react';

import { ZIndexContext } from './../../ricos-context';

import classes from '../statics/styles/toggle-button-scss';

type ToggleButtonProps = {
  checked: boolean;
  onChange: () => void;
  title: string;
  infoContent?: React.ReactNode;
  dataHook: string;
  size?: 'small' | 'medium' | 'large';
  toolTipSize?: 'small' | 'medium';
  tooltipAppendTo?: TooltipCommonProps['appendTo'];
  disabled?: boolean;
};

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  checked,
  onChange,
  title,
  infoContent,
  dataHook,
  size,
  toolTipSize = 'medium',
  tooltipAppendTo,
  disabled,
}) => {
  const zIndexService = useContext(ZIndexContext);

  return (
    <Box verticalAlign="middle" align="space-between" className={classes.root} gap="9px">
      {infoContent ? (
        <Box verticalAlign="middle" gap="SP1">
          <Text size="small">{title}</Text>
          <InfoIcon
            size="small"
            content={infoContent}
            tooltipProps={{
              appendTo:
                tooltipAppendTo ??
                (el => Boolean(el.getAttribute('data-hook')?.includes('ricos-portal'))),
              zIndex: zIndexService.getZIndex('TOOLTIP'),
              size: toolTipSize,
              enterDelay: 300,
            }}
          />
        </Box>
      ) : (
        <Text size="small">{title}</Text>
      )}
      <ToggleSwitch
        size={size}
        checked={checked}
        onChange={onChange}
        dataHook={dataHook}
        disabled={disabled}
      />
    </Box>
  );
};
